import * as yup from 'yup'
import { ftpProfileFormFields as FPF } from 'components/ftpProfiles/utils'

export const createFtpProfileSchema = yup
  .object()
  .shape({
    [FPF.FTP_PROFILE_NAME.key]: yup
      .string()
      .required('Name is a required field'),
    [FPF.FTP_PROFILE_PROTOCOL.key]: yup
      .string()
      .oneOf(['FTP', 'SFTP'])
      .required('Protocol is a required field'),
    [FPF.FTP_PROFILE_HOST.key]: yup
      .string()
      .required('Host is a required field'),
    [FPF.FTP_PROFILE_PORT.key]: yup
      .number()
      .typeError('Port must be a number')
      .optional(),
    [FPF.FTP_PROFILE_USERNAME.key]: yup.string().optional(),
    [FPF.FTP_PROFILE_PASSWORD.key]: yup.string().optional(),
    [FPF.FTP_PROFILE_DIRECTORY.key]: yup.string().optional(),
    [FPF.FTP_PROFILE_IS_ENABLE.key]: yup.boolean().optional(),
  })
  .required()

export const updateFtpProfileSchema = createFtpProfileSchema
